<script lang="ts">
	// Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	// Services and configs
	import { devices_config } from 'src/configs/devices';
	// Helpers
	import { get_mode, real_id, lightDevicesWithoutModeSwitch } from 'src/helpers/interface_helpers';
	import { isXMODDevice, isRgbwwPm } from 'src/helpers/interface_helpers';
	// Design System Components
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	// Components
	import ControlMode from 'src/components/Controls/Single/ControlMode.svelte';
	import ControlColor from 'src/components/Controls/Single/ControlColor.svelte';
	import ControlTemp from 'src/components/Controls/Single/ControlTemp.svelte';
	import ControlEffects from 'src/components/Controls/Single/ControlEffects.svelte';
	import { ControlsContainer } from '@Shelly/shelly-design-system';
	// Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;
	$: mode = get_mode(device, status, settings);
	$: deviceConfig = devices_config?.[device?.type];

	// Check if device has color control and color temp control (similar to DeviceDrawer logic)
	$: hasColorTempControl = isXMODDevice(device?.type)
		? status?.['cct:0'] && device?.mode === 'cct'
		: deviceConfig?.modes?.[mode]?.color_temp;
	$: hasColorControl = isXMODDevice(device?.type)
		? status?.['rgbw:0'] && device?.mode === 'rgbw'
		: deviceConfig?.modes?.[mode]?.color;

	// Check for effects
	$: hasEffects = deviceConfig?.modes?.[mode]?.effects;

	// XMOD and RGBWW PM specific checks
	$: isXMODCct = isXMODDevice(device?.type) && device?.mode === 'cct';
	$: isXMODRgbw = isXMODDevice(device?.type) && device?.mode === 'rgbw';
	$: isRgbwwPmCct = isRgbwwPm(device?.type) && device?.mode === 'cct';
</script>

<SidepanelContent>
	{#if device && typeof status !== 'undefined' && typeof settings !== 'undefined' && typeof deviceConfig !== 'undefined'}
		{#if !isXMODDevice(device?.type) && (hasColorControl || hasColorTempControl) && !lightDevicesWithoutModeSwitch(device.type)}
			<ControlMode {device} {settings} {mode} />
		{:else if hasColorControl && hasEffects}
			<ControlsContainer class="mb-m" color="color-0">
				<div slot="first">
					<ControlEffects {device} />
				</div>
			</ControlsContainer>
		{/if}

		{#if isXMODCct || isRgbwwPmCct || mode === 'white' || mode === 'cct' || (mode === 'rgbcct' && settings?.[`${mode}:0`]?.mode === 'cct')}
			<ControlTemp {device} {status} />
		{:else if isXMODRgbw || !isXMODDevice(device?.type)}
			<ControlColor {device} {status} />
		{/if}
	{:else}
		<div class="loading-state">
			<div class="flex-full-height"></div>
		</div>
	{/if}
</SidepanelContent>
